import React from 'react'
import Pagination from '../../../components/Pagination'
import TransactionsCard from '../mobile/TransactionsCard'

const headerClasses =
  'px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-customLightMilkWhite dark:text-customMuted'

const TransactionsTable = ({
  data,
  page,
  pageSize,
  totalItems,
  onPageChange,
  onPageSizeChange,
  onAction,
  isMobile
}) => {
  if (isMobile) {
    return (
      <div className="space-y-4">
        <TransactionsCard data={data} onAction={onAction} />
        <Pagination
          page={page}
          pageSize={pageSize}
          totalItems={totalItems}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          pageSizeOptions={[5, 10, 20]}
          className="rounded-2xl border border-customAccentBlue/15 bg-white/90 shadow-lg shadow-customAccentBlue/10 dark:border-customSurfaceMuted dark:bg-customSurface"
        />
      </div>
    )
  }

  return (
    <div className="overflow-hidden rounded-md border border-customBorder/30 bg-white shadow-lg shadow-customPredawn/20 dark:border-custom_dark_secondary/40 dark:bg-customSurface">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-customBorder/20 dark:divide-white/5">
          <thead className="bg-background dark:bg-customSurfaceMuted">
            <tr>
              <th className={headerClasses}>ID</th>
              <th className={headerClasses}>Transaction</th>
              <th className={headerClasses}>Account</th>
              <th className={headerClasses}>Username</th>
              <th className={headerClasses}>Amount</th>
              <th className={headerClasses}>Type</th>
              <th className={`${headerClasses} text-center`}>Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-customBorder/10 bg-white dark:divide-white/5 dark:bg-customSurface">
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan={7}
                  className="px-4 py-10 text-center text-sm text-customSecondaryText dark:text-customMuted"
                >
                  All caught up! No pending deposits or withdrawals matching your filters.
                </td>
              </tr>
            ) : (
              data.map((transaction) => (
                <tr
                  key={transaction.id}
                  className="transition hover:bg-customLightMilkWhite/60 dark:hover:bg-customSurfaceMuted/40"
                >
                  <td className="whitespace-nowrap px-2 py-3 text-sm font-semibold text-customPrimaryText dark:text-customHeading">
                    #{transaction.id}
                  </td>
                  <td className="px-2 py-3 text-sm text-customPrimaryText dark:text-customLightMilkWhite w-10">
                    <div className="font-medium text-customAccentBlue">
                      {transaction.transactionNo}
                    </div>
                    <div className="text-xs text-customSecondaryText dark:text-customMuted">
                      {transaction.createdDate}
                    </div>
                    <div className="mt-1 rounded-lg bg-customLightMilkWhite/80 px-2 py-1 text-xs text-customSecondaryText dark:bg-white/5 dark:text-customMuted">
                      {transaction.remark}
                    </div>
                  </td>
                  <td className='px-4 py-3 text-sm text-customPrimaryText dark:text-customLightMilkWhite'>
                    <div className="flex gap-2">
                      <img
                        src={require(`../../../assets/banks/${transaction?.bankType}.png`)}
                        alt={transaction.bankType}
                        className="h-5 w-5 rounded-full object-cover"
                        onError={(e) => { e.target.onerror = null; e.target.src = require('../../../assets/banks/dollar.png'); }}
                      />
                      <span className="text-xs text-customPrimaryText dark:text-customHeading">
                      {transaction.accountName}
                    </span>
                    </div>
                    <div className="mt-1 rounded-lg bg-customLightMilkWhite/80 px-2 py-1 text-xs text-customSecondaryText dark:bg-white/5 dark:text-customMuted">
                      {transaction.accountNo}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm text-customPrimaryText dark:text-customLightMilkWhite">
                    <div className="font-semibold text-customPrimaryText dark:text-customHeading">
                      {transaction.username}
                    </div>
                    <div className="text-xs text-customSecondaryText dark:text-customMuted">
                      {transaction.email}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm font-semibold text-customFontVoilet dark:text-customVibrantGreen">
                    {transaction.amount.toLocaleString(undefined, {
                      style: 'currency',
                      currency: transaction.currency,
                    })}
                  </td>
                  <td className="px-2 py-3 text-sm f">
                    <span
                      className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide ${
                        transaction.type === 'deposit'
                          ? 'bg-customDarkGreen/10 text-customDarkGreen'
                          : 'bg-customFontRed/10 text-customFontRed'
                      }`}
                    >
                      <span
                        className={`h-2.5 w-2.5 rounded-full ${
                          transaction.type === 'deposit'
                            ? 'bg-customDarkGreen'
                            : 'bg-customFontRed'
                        }`}
                        aria-hidden="true"
                      />
                      {transaction.type}
                    </span>
                  </td>
                  <td className="px-2 py-3 text-sm">
                    <div className={`flex ${isMobile ? '' : 'flex-wrap'} justify-center gap-2`}>
                      <button
                        type="button"
                        onClick={() => onAction(transaction, 'approve')}
                        className="rounded-md bg-customDarkGreen px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-customWhite shadow-sm transition hover:bg-customDarkGreen/90 focus:outline-none focus:ring-2 focus:ring-customDarkGreen/40"
                      >
                        Approve
                      </button>
                      <button
                        type="button"
                        onClick={() => onAction(transaction, 'reject')}
                        className="rounded-md bg-customFontRed px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-customWhite shadow-sm transition hover:bg-customFontRed/90 focus:outline-none focus:ring-2 focus:ring-customFontRed/40"
                      >
                        Reject
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <Pagination
        page={page}
        pageSize={pageSize}
        totalItems={totalItems}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        pageSizeOptions={[5, 10, 20]}
        className="rounded-b-2xl bg-customLightMilkWhite/50 dark:bg-customSurfaceMuted/60"
      />
    </div>
  )
}

export default TransactionsTable
